module.exports = __webpack_public_path__ + "1f53b09d22abb93d7ee6e9fe85e489cd.png";